module.exports = [
	{
		"featureType": "all",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"saturation": 36
			},
			{
				"color": "#ffffff"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.text.stroke",
		"stylers": [
			{
				"visibility": "on"
			},
			{
				"color": "#df9dc6"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			},
			{
				"weight": ".5"
			}
		]
	},
	{
		"featureType": "all",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#844b8d"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "administrative",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#844b8d"
			},
			{
				"lightness": "0"
			},
			{
				"weight": 1.2
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#844b8d"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#b47eaf"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#965b98"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.fill",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "geometry.stroke",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": "0"
			},
			{
				"weight": 0.2
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#df9dc6"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "road.local",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#df9dc6"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#ffffff"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	},
	{
		"featureType": "transit.station.airport",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#b47eaf"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [
			{
				"color": "#9d6fa4"
			},
			{
				"lightness": "0"
			},
			{
				"gamma": "1"
			}
		]
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/location/elements/mapstyle.json
 ** module id = 249
 ** module chunks = 0
 **/